import LayerGroup from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';import { urlWMSInundaciones, formatoPNG } from './configuracion';

const  layer00425 = new TileLayer({
  title: 'Máscara 19860103',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19860103l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00425.setVisible(false);

const layer00424 = new TileLayer({
  title: 'Máscara 19860119',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19860119l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00424.setVisible(false);

const layer00423 = new TileLayer({
  title: 'Máscara 19860527',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19860527l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00423.setVisible(false);

const layer00422 = new TileLayer({
  title: 'Máscara 19860612',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19860612l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00422.setVisible(false);

const layer00421 = new TileLayer({
  title: 'Máscara 19860628',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19860628l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00421.setVisible(false);

const layer00420 = new TileLayer({
  title: 'Máscara 19860730',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19860730l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00420.setVisible(false);

export const grupoCapa01_36 = new LayerGroup({
  title: 'Ciclo Hidrológico 1985-1986',
  fold: 'close',
  layers: [layer00420, layer00421, layer00422, layer00423, layer00424, layer00425]
});